import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from 'src/components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Cait = makeShortcode("Cait");
const NoCait = makeShortcode("NoCait");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler Primrose AMS Notes" mdxType="SEO" />
    <p>{`This route is outdated in favor of `}<a parentName="p" {...{
        "href": "/Octopath-Traveler/Full-Game/AMS-Primrose-2022"
      }}>{`this route`}</a>{`.`}</p>
    <h2 {...{
      "id": "primrose-all-main-stories-route"
    }}>{`Primrose All Main Stories Route`}</h2>
    <h3 {...{
      "id": "tressa-ch1"
    }}>{`Tressa Ch.1`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Wolf’s Bow`}</strong>{`. Run/Break from all encounters.`}</p>
    <p>{`Kill `}<strong parentName="p">{`Pirate`}</strong>{` `}<strong parentName="p">{`I/II`}</strong>{` with Defend, Bow, Tradewinds x4 for 5 JP.`}</p>
    <p>{`Get `}<strong parentName="p">{`Thunder S`}</strong>{` and start fight`}</p>
    <h4 {...{
      "id": "mikk-and-makk"
    }}>{`Mikk and Makk`}</h4>
    <ol>
      <li parentName="ol">{`Spear x2 on Mikk`}</li>
      <li parentName="ol">{`Bow on Makk`}</li>
      <li parentName="ol">{`Tradewinds Makk until on `}<strong parentName="li">{`1`}</strong>{` break + `}<strong parentName="li">{`full BP`}</strong>{` (grape as needed)`}</li>
      <li parentName="ol">{`Tradewinds x4 Makk`}</li>
      <li parentName="ol">{`Thunder S`}</li>
      <li parentName="ol">{`Tradewinds x4 Mikk`}</li>
    </ol>
    <p>{`Mikk attack deals ~37-40`}<br parentName="p"></br>{`
`}{`Mutiny deals ~48`}<br parentName="p"></br>{`
`}{`Slice deals ~60  `}</p>
    <p>{`Makk attack deals ~22`}<br parentName="p"></br>{`
`}{`Slice deals ~38`}<br parentName="p"></br>{`
`}{`Mutiny deals ~31  `}</p>
    <p>{`Run to `}<strong parentName="p">{`Atlasdam`}</strong>{`, completing the Kit sidequest immediately. If cait encounter kill it and toggle cait.`}</p>
    <Cait mdxType="Cait">
      <p>{`Tag `}<strong parentName="p">{`Atlasdam`}</strong>{`, head to `}<strong parentName="p">{`Scholar Shrine`}</strong>{`.`}</p>
      <p>{`To deal with the Scholar shrine encounter, you can either run OR teach `}<strong parentName="p">{`Hired Help`}</strong>{` before the encounter and do HHDx2, Bow, then Bow x2.`}</p>
      <p>{`Tag `}<strong parentName="p">{`Atlasdam`}</strong>{`, Get `}<strong parentName="p">{`Scholar Shrine`}</strong>{`,  teach first 2 scholar skills and equip `}<strong parentName="p">{`Evasive Maneuvers.`}</strong>{` get `}<strong parentName="p">{`Wind Amulet`}</strong>{` and tag `}<strong parentName="p">{`Noblecourt`}</strong>{`.  TP to `}<strong parentName="p">{`Rippletide`}</strong>{`, head towards Cobbleton. Pick `}<strong parentName="p">{`1200$`}</strong>{`, tag `}<strong parentName="p">{`Cobbleston`}</strong>{`, optionally buy `}<strong parentName="p">{`Curious Bloom`}</strong>{` from the NPC near the exit. Head to `}<strong parentName="p">{`North Stonegard Pass`}</strong>{`.`}</p>
      <blockquote>
        <p parentName="blockquote">{`Break encounter in North Stonegard Pass with 2xBandits and flee.`}</p>
      </blockquote>
      <p>{`Get `}<strong parentName="p">{`Warrior Shrine`}</strong>{`, tag `}<strong parentName="p">{`Stonegard`}</strong>{`, go to `}<strong parentName="p">{`Moonstruck Coast`}</strong>{`. S&Q at save, get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`, tag `}<strong parentName="p">{`Goldshore`}</strong>{`. Head towards `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
      <blockquote>
        <p parentName="blockquote">{`Since we don't have Cyrus, we can't do `}<strong parentName="p">{`A Safe Route`}</strong>{` quest. You will need to get the `}<strong parentName="p">{`Death Cleaver`}</strong>{` from the `}<strong parentName="p">{`Everhold Tunnels`}</strong>{` to make up for the lost money.`}</p>
      </blockquote>
      <p><strong parentName="p">{`West Grandport Coast`}</strong>{` get `}<strong parentName="p">{`Wind L`}</strong>{`, go north to reload screen, back in to get `}<strong parentName="p">{`$20000`}</strong>{`, and save/reload at save point.  Get `}<strong parentName="p">{`Thunder L`}</strong>{` from the chest south of save point, and enter `}<strong parentName="p">{`Grandport`}</strong>{`. `}</p>
      <p>{`Buy the `}<strong parentName="p">{`+50 accuracy`}</strong>{` necklace at the weapon shop, go to tavern and buy `}<strong parentName="p">{`Nourishing M`}</strong>{` and `}<strong parentName="p">{`Magic M`}</strong>{` from the merchant in the middle.  On the next screen, buy a `}<strong parentName="p">{`Pom L`}</strong>{` from the noble in red, get the `}<strong parentName="p">{`Silver-Filled Pouch`}</strong>{`, buy another `}<strong parentName="p">{`Pom L`}</strong>{` from the man in green, and all `}<strong parentName="p">{`pomegranates`}</strong>{` from the lady in red.  On the next screen, get `}<strong parentName="p">{`$25000 + Artwork`}</strong>{`, and TP to `}<strong parentName="p">{`Atlasdam`}</strong>{`.`}</p>
      <h3 {...{
        "id": "cyrus-ch1"
      }}>{`Cyrus Ch.1`}</h3>
      <p>{`Buy `}<strong parentName="p">{`herbs`}</strong>{` at the shop`}</p>
      <h4 {...{
        "id": "russel"
      }}>{`Russel`}</h4>
      <p>{`Wind L`}</p>
      <p>{`TP `}<strong parentName="p">{`Stonegard`}</strong>{`. Go east to the next screen, go down the stairs and buy all `}<strong parentName="p">{`M Soulstones`}</strong>{` from the guy guarding the first house.  Buy `}<strong parentName="p">{`Elemental Augmentor`}</strong>{` from the old man at the end, then TP to `}<strong parentName="p">{`Cobbleston`}</strong>{` and head to `}<strong parentName="p">{`Sunshade`}</strong>{`. Get the `}<strong parentName="p">{`Old Coin`}</strong>{` on the way.`}</p>
    </Cait>
    <NoCait mdxType="NoCait">
      <h3 {...{
        "id": "cyrus-ch1-1"
      }}>{`Cyrus Ch.1`}</h3>
      <p>{`Buy `}<strong parentName="p">{`herbs`}</strong>{` at the shop`}</p>
      <p>{`Grind two encounters (Break first turn, Tradewinds x3 second turn) and learn `}<strong parentName="p">{`Hired Help`}</strong>{`.`}</p>
      <h4 {...{
        "id": "russel-1"
      }}>{`Russel`}</h4>
      <p>{`Tressa - Ice M`}<br parentName="p"></br>{`
`}{`Cyrus - Defend  `}</p>
      <p>{`Tressa - HHDx3`}<br parentName="p"></br>{`
`}{`Cyrus - Staffx3  `}</p>
      <p>{`Scrutinize `}<strong parentName="p">{`Light M`}</strong>{` from little girl in courtyard, and teach Cyrus `}<strong parentName="p">{`Lightning Bolt`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`herbs`}</strong>{` if you haven't already.`}</p>
      <h4 {...{
        "id": "exploration-1"
      }}>{`Exploration 1`}</h4>
      <p>{`Grind Whistlewood (use `}<strong parentName="p">{`Light M`}</strong>{` on encounter) + Atlasdam (use HHB x2) if needed to get 100 JP for `}<strong parentName="p">{`Fire Storm`}</strong>{`.`}</p>
      <p>{`Get `}<strong parentName="p">{`Scholar Shrine`}</strong>{`, get `}<strong parentName="p">{`Wind Amulet`}</strong>{` and enter `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
      <p>{`Scrutinize `}<strong parentName="p">{`Thunder L`}</strong>{` from lady at the beginning.`}</p>
      <p>{`TP `}<strong parentName="p">{`Rippletide`}</strong>{` and tag `}<strong parentName="p">{`Cobbleston`}</strong>{`, get `}<strong parentName="p">{`$1500`}</strong>{` chest on the way.  Buy `}<strong parentName="p">{`herbs`}</strong>{` if you didn't in Atlasdam.`}</p>
      <blockquote>
        <p parentName="blockquote">{`Break encounter in North Stonegard Pass with 2xBandits and flee.`}</p>
      </blockquote>
      <p>{`Go to `}<strong parentName="p">{`North Stonegard Pass`}</strong>{`. Get `}<strong parentName="p">{`Warrior Shrine`}</strong>{`, tag `}<strong parentName="p">{`Stonegard`}</strong>{`, go to `}<strong parentName="p">{`Moonstruck Coast`}</strong>{`. S&Q at save, get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`, tag `}<strong parentName="p">{`Goldshore`}</strong>{`. Head towards `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
      <p>{`Reload at save before shrine, and get shrine, then go to `}<strong parentName="p">{`Goldshore`}</strong>{`, scrutinize old man (get item later) and leave.  Scrutinize the man on the way for `}<strong parentName="p">{`A Safe Route`}</strong>{`, enter next screen and get `}<strong parentName="p">{`Wind L`}</strong>{`, go north to reload screen, back in to get `}<strong parentName="p">{`$20000`}</strong>{`, and save/reload at save point.  Get `}<strong parentName="p">{`Thunder L`}</strong>{` from the chest south of save point, and tag `}<strong parentName="p">{`Grandport`}</strong>{`. `}</p>
      <p>{`Buy the `}<strong parentName="p">{`+50 accuracy`}</strong>{` necklace at the weapon shop, go to tavern and buy `}<strong parentName="p">{`Nourishing M`}</strong>{` and `}<strong parentName="p">{`Magic M`}</strong>{` from the merchant in the middle.  On the next screen, buy a `}<strong parentName="p">{`Pom L`}</strong>{` from the noble in red, get the `}<strong parentName="p">{`Silver-Filled Pouch`}</strong>{`, buy another `}<strong parentName="p">{`Pom L`}</strong>{` from the man in green, and all `}<strong parentName="p">{`pomegranates`}</strong>{` from the lady in red.  On the next screen, get `}<strong parentName="p">{`$25000 + Artwork`}</strong>{`, and TP to `}<strong parentName="p">{`Stonegard`}</strong>{`.`}</p>
      <p>{`Go east to the next screen, go down the stairs and buy all `}<strong parentName="p">{`M Soulstones`}</strong>{` from the guy guarding the first house.  Buy `}<strong parentName="p">{`Elemental Augmentor`}</strong>{` from the old man at the end, then TP to `}<strong parentName="p">{`Cobbleston`}</strong>{` and head to `}<strong parentName="p">{`Sunshade`}</strong>{`. Get the `}<strong parentName="p">{`Old Coin`}</strong>{` on the way.`}</p>
    </NoCait>
    <h3 {...{
      "id": "primrose-ch1"
    }}>{`Primrose Ch.1`}</h3>
    <p>{`Recruit Primrose, then head through the dungeon (Escape or HHB x2 if needed)`}</p>
    <h4 {...{
      "id": "helgenish"
    }}>{`Helgenish`}</h4>
    <p>{`L Stone + M Stone`}</p>
    <p>{`Tag `}<strong parentName="p">{`Clearbrook`}</strong>{`, Tag `}<strong parentName="p">{`Quarrycrest`}</strong>{` (start Tressa 2).  `}</p>
    <h3 {...{
      "id": "tressa-ch2-start"
    }}>{`Tressa Ch.2 Start`}</h3>
    <p>{`Do story prompts. `}</p>
    <Cait mdxType="Cait">
Buy a <strong>Thunder M</strong> and <strong>Thunder L</strong> from the guy on the way to the stairs.
    </Cait>
    <p>{`Buy both `}<strong parentName="p">{`M Soulstones`}</strong>{` from the second quest guy you buy stones from. Pick `}<strong parentName="p">{`Fool's Gold Ore`}</strong>{` from chest by last quest guy.`}</p>
    <p>{`TP to `}<strong parentName="p">{`Rippletide`}</strong>{`, Scrutinize & pick `}<strong parentName="p">{`Thunder L`}</strong>{`, TP back to `}<strong parentName="p">{`Quarrycrest`}</strong>{`. Head to `}<strong parentName="p">{`Bolderfall`}</strong>{` (can use up to 1M Soulstones for encounter)`}</p>
    <h3 {...{
      "id": "therion-ch1"
    }}>{`Therion Ch.1`}</h3>
    <p>{`Quit + Reload in Ravus Manor (or first turn escape to save ~9s)`}</p>
    <h4 {...{
      "id": "heathecote"
    }}>{`Heathecote`}</h4>
    <p>{`T1 Any - Thunder L + Thunder/Ice/Fire M + Any M Stone`}</p>
    <p>{`Steal `}<strong parentName="p">{`all items`}</strong>{` from Elderly Woman, `}<strong parentName="p">{`Steal Nourish Nut`}</strong>{` + `}<strong parentName="p">{`Pom S`}</strong>{` from girl before exiting.`}</p>
    <h3 {...{
      "id": "exploration-2"
    }}>{`Exploration 2`}</h3>
    <p>{`Get `}<strong parentName="p">{`Hunter Shrine`}</strong>{`, get `}<strong parentName="p">{`Olive L`}</strong>{` and tag `}<strong parentName="p">{`Victors Hollow`}</strong>{`, buy `}<strong parentName="p">{`all 3 nuts`}</strong>{` from guy near exit, reload at `}<strong parentName="p">{`Hunter Shrine`}</strong>{`, get `}<strong parentName="p">{`Cleric Shrine`}</strong>{`, go to  `}<strong parentName="p">{`Stillsnow`}</strong>{`. `}</p>
    <blockquote>
      <p parentName="blockquote">{`You can skip going to `}<strong parentName="p">{`Hunter Shrine`}</strong>{` before tagging `}<strong parentName="p">{`Victor's Hollow`}</strong>{` and get it on the way to `}<strong parentName="p">{`Stillsnow`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Saves ~15s but risks a battle on the way to `}<strong parentName="p">{`Victors Hollow`}</strong>{`.`}</p>
    </blockquote>
    <h3 {...{
      "id": "primrose-ch2-start"
    }}>{`Primrose Ch.2 Start`}</h3>
    <p>{`Scrutinize `}<strong parentName="p">{`Silver Pouch`}</strong>{`. Do story stuff, pick `}<strong parentName="p">{`Shadow M`}</strong>{`, talk to `}<strong parentName="p">{`Arianna`}</strong>{`, and TP to `}<strong parentName="p">{`Quarrycrest`}</strong>{`.`}</p>
    <p>{`Leave `}<strong parentName="p">{`Quarrycrest`}</strong>{`, get `}<strong parentName="p">{`Pom S`}</strong>{` from the chest, (can use `}<strong parentName="p">{`Wind L`}</strong>{` on encounter OR break with bandits/fire), go to the next area and `}<strong parentName="p">{`S+Q`}</strong>{` at savepoint, tag `}<strong parentName="p">{`Orewell`}</strong>{`, and go to `}<strong parentName="p">{`Riverford`}</strong>{`.  Scrutinize the left guard (but don’t pick up the item).`}</p>
    <p>{`Warp to `}<strong parentName="p">{`Sunshade`}</strong>{`, head out to the right. Tag `}<strong parentName="p">{`Dancer Shrine`}</strong>{`, reload at south exit, tag `}<strong parentName="p">{`Wellspring`}</strong>{`.`}</p>
    <p>{`Get `}<strong parentName="p">{`Thunder L`}</strong>{` + `}<strong parentName="p">{`$20000`}</strong>{` chest in screen before `}<strong parentName="p">{`Marsalim`}</strong>{`, reload at `}<strong parentName="p">{`Marsalim Catacombs`}</strong>{`.`}</p>
    <p>{`Enter `}<strong parentName="p">{`Marsalim`}</strong>{`, buy `}<strong parentName="p">{`Invigorating M, Magic M`}<NoCait mdxType="NoCait">{`, Resistant M`}</NoCait></strong>{` from guy by entrance near shop. Go to palace, buy 2 `}<strong parentName="p">{`Pom M`}</strong>{` from left guard, pick `}<strong parentName="p">{`Tempest Amulet`}</strong>{`, pick the 3 chests in right room. Can optionally scrutinize & pick `}<strong parentName="p">{`Fire L`}</strong>{` from right guard.`}</p>
    <p>{`TP to `}<strong parentName="p">{`Stonegard`}</strong>{`, go to `}<strong parentName="p">{`West Everhold Pass`}</strong>{`. Pick `}<strong parentName="p">{`Light L`}</strong>{` + `}<strong parentName="p">{`Pouch`}</strong>{`, `}<strong parentName="p">{`Save & Reload`}</strong>{`, enter `}<strong parentName="p">{`Everhold`}</strong>{`. Buy `}<strong parentName="p">{`Sorcerer’s Robe`}</strong>{`. Go back and `}<strong parentName="p">{`Save & Reload`}</strong>{`, get `}<strong parentName="p">{`Pom M`}</strong>{`, go to `}<strong parentName="p">{`West Everhold Tunnels`}</strong>{`.`}</p>
    <NoCait mdxType="NoCait">
      <p>{`Get `}<strong parentName="p">{`Pom L`}</strong>{`, reset steps, get `}<strong parentName="p">{`$35000`}</strong>{`, get `}<strong parentName="p">{`Knowledge Staff`}</strong>{`.`}</p>
    </NoCait>
    <Cait mdxType="Cait">
      <p>{`Get `}<strong parentName="p">{`Pom L`}</strong>{`, reset steps. get `}<strong parentName="p">{`$35000`}</strong>{`, `}<strong parentName="p">{`Knowledge Staff`}</strong>{`, `}<strong parentName="p">{`Death Cleaver`}</strong>{`, resetting steps in between all of them.`}</p>
    </Cait>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`, `}<em parentName="p">{`deny chapter start prompt`}</em>{`. Leave Noblecourt.`}</p>
    <p>{`Steal `}<strong parentName="p">{`Oasis Hat`}</strong>{` from the man near the tent, then head to `}<strong parentName="p">{`Flamesgrace`}</strong>{`.  `}</p>
    <h3 {...{
      "id": "ophilia-ch1"
    }}>{`Ophilia Ch.1`}</h3>
    <p>{`Replace `}<strong parentName="p">{`Cyrus`}</strong>{` with `}<strong parentName="p">{`Ophilia`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: `}<em parentName="li">{`Donate BP if JP > 230`}</em>{`, `}<strong parentName="li">{`Scholar`}</strong>{` + first 2 Scholar skills if Primrose JP < 130`}</li>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Scholar`}</strong>{` + Blizzard (+ Lightning Blast if applicable)`}</li>
      </ul>
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose or Tressa: EM`}</li>
      </ul>
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Enchanted Circlet`}</li>
        <li parentName="ul">{`Primrose: Knowledge Staff, Sorc Robe, Elemental Augmentor`}</li>
        <li parentName="ul">{`Ophilia: Optimize`}</li>
      </ul>
      <h5 {...{
        "id": "formation"
      }}>{`Formation`}</h5>
      <p>{`Swap Tressa’s position with Primrose `}</p>
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul"><NoCait mdxType="NoCait">1x Nourishing M Tressa</NoCait>  </li>
        <li parentName="ul"><Cait mdxType="Cait">1x Nourishing S Tressa</Cait>  </li>
        <li parentName="ul">{`All others to Prim`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "guardian"
    }}>{`Guardian`}</h4>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`Use second option if Tressa has Donate BP`}</em></li>
      <li parentName="ul">{`Primrose: Blizzard OR 2x Blizzard`}</li>
      <li parentName="ul">{`Ophilia: 2x Staff`}</li>
      <li parentName="ul">{`Tressa: Pom S Prim OR Defend`}</li>
      <li parentName="ul">{`Therion: 2x Dagger`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Primrose: 3x Blizzard OR 4x Blizzard`}</li>
      <li parentName="ul">{`Tressa: 3x Tradewinds (damage range) OR 3x Donate BP`}</li>
      <li parentName="ul">{`Ophilia/Therion: M Stone`}</li>
    </ul>
    <h3 {...{
      "id": "ophilia-ch2"
    }}>{`Ophilia Ch.2`}</h3>
    <p>{`TP to `}<strong parentName="p">{`Sunshade`}</strong>{`, head towards `}<strong parentName="p">{`Saintsbridge`}</strong>{`. Get `}<strong parentName="p">{`Apothecary Shrine`}</strong>{`, Start Ophilia 2`}</p>
    <p>{`Before guiding Derryl get `}<strong parentName="p">{`Heavy Coin Pouch`}</strong>{`.`}</p>
    <p>{`Kill encounter before Murkwood -  Lightning Blast x3 OR Soulstone M, get 3.5k`}<br parentName="p"></br>{`
`}{`Murkwood, kill encounter with Lightning Blast x2 + M stone OR Thunder L.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Lightning Blast`}</li>
        <li parentName="ul">{`Ophilia: Heal More, `}<strong parentName="li">{`Merchant`}</strong>{` + Donate BP + Hired Help`}</li>
        <li parentName="ul">{`Tressa: `}<em parentName="li">{`Donate BP`}</em>{` if not learned already, `}<strong parentName="li">{`Hunter`}</strong>{` + Arrowstorm`}</li>
        <li parentName="ul">{`Therion: Shackle Foe + Armor Corrosive, `}<strong parentName="li">{`Dancer`}</strong>{` + Peacock Strut `}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "hrodvitnir"
    }}>{`Hrodvitnir`}</h4>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Primrose: Defend`}</li>
      <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Spear`}</strong></li>
      <li parentName="ul">{`Tressa: Attack`}</li>
      <li parentName="ul">{`Therion: 2x `}<strong parentName="li">{`Sword`}</strong></li>
    </ul>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Primrose: Lightning Blast`}</li>
      <li parentName="ul">{`Ophilia/Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Ophilia/Tressa: HHV x4 + Collect`}</li>
      <li parentName="ul">{`Primrose: Lightning Blast x4`}</li>
      <li parentName="ul">{`Therion: Peacock (if before Prim) or Soulstone M`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`You can optionally save here before scrutinizing the NPC.`}</p>
    </blockquote>
    <p>{`Go to tavern, swap `}<strong parentName="p">{`Therion`}</strong>{` for `}<strong parentName="p">{`Cyrus`}</strong>{`. Scrutinize NPC on bridge, finish Chapter.`}<br parentName="p"></br>{`
`}{`After completing chapter,`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "item-shop"
      }}>{`Item Shop`}</h5>
      <ul>
        <li parentName="ul">{`Buy 11 of each herb`}</li>
        <li parentName="ul">{`Sell all gold items. `}<Cait mdxType="Cait">{`Sell Death Cleaver.`}</Cait></li>
      </ul>
      <p><em parentName="p">{`You should have approximately `}<Cait mdxType="Cait">{`$137000`}</Cait><NoCait mdxType="NoCait">{`$126000`}</NoCait>{` here after selling.`}</em></p>
      <h5 {...{
        "id": "armor-shop"
      }}>{`Armor Shop`}</h5>
      <ul>
        <li parentName="ul">{`6 Empowering Bracelets`}</li>
        <li parentName="ul">{`Saintly Tiara for `}<strong parentName="li">{`Tressa`}</strong></li>
        <li parentName="ul">{`2 Charm Robe for `}<strong parentName="li">{`Tressa`}</strong></li>
        <li parentName="ul">{`3 Elemental Shields on `}<strong parentName="li">{`Tressa/Ophilia`}</strong></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "ophilia-ch3"
    }}>{`Ophilia Ch.3`}</h3>
    <p>{`TP `}<strong parentName="p">{`Goldshore`}</strong>{`, pick `}<strong parentName="p">{`$4500`}</strong>{`, `}<NoCait mdxType="NoCait">{`complete quest,`}</NoCait>{` scrutinize lady, pick `}<strong parentName="p">{`Pom M`}</strong>{` and get the `}<strong parentName="p">{`Wind L`}</strong>{`.  `}</p>
    <p>{`After guiding NPC to cathedral, TP `}<strong parentName="p">{`Grandport`}</strong>{`, go to `}<strong parentName="p">{`Loch`}</strong>{` to get `}<strong parentName="p">{`$30000`}</strong>{` + `}<strong parentName="p">{`Wind L`}</strong>{` (if not done already), and TP back to `}<strong parentName="p">{`Goldshore`}</strong>{`.  `}</p>
    <p>{`Scrutinize the old man and get the `}<strong parentName="p">{`Thunder L`}</strong>{`, and pick `}<strong parentName="p">{`Thunder M`}</strong>{` chest.`}<br parentName="p"></br>{`
`}{`Swap `}<strong parentName="p">{`Cyrus`}</strong>{` for `}<strong parentName="p">{`Therion`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Tressa/Ophilia: 2 Empowering Bracelet`}</li>
        <li parentName="ul">{`Therion: Optimize + 2 Empowering Bracelet`}</li>
      </ul>
      <h5 {...{
        "id": "healing"
      }}>{`Healing`}</h5>
      <p>{`Heal all w/ Ophilia`}</p>
    </Menu>
    <p>{`If you get an encounter before the grotto, kill the encounter with Lightning Blast x2/3 + and a soulstone L/M.  You can skip Prim 3 encounter if you kill this encounter.`}</p>
    <p>{`Enter Grotto, kill encounter with any L + Lightning Blast x2 (only use Light L on cultists) `}</p>
    <blockquote>
      <p parentName="blockquote">{`If you had to restore reputation in Saintsbridge, pick `}<strong parentName="p">{`Silver Filled Pouch`}</strong>{` before boss.`}</p>
    </blockquote>
    <h4 {...{
      "id": "mystery-man--shady-figure"
    }}>{`Mystery Man & Shady Figure`}</h4>
    <h5 {...{
      "id": "turn-1-2"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Primrose: Pom M Ophilia`}</li>
      <li parentName="ul">{`Tressa: Attack MM / HHB if worried about miss`}</li>
      <li parentName="ul">{`Ophilia: Defend`}</li>
      <li parentName="ul">{`Therion: 2x Armor Corrosive MM`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: HHBx4`}</li>
      <li parentName="ul">{`Primrose: Pom M Ophilia`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive SF`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: HHMx4`}</li>
      <li parentName="ul">{`Primrose: Lightning Blastx4`}</li>
      <li parentName="ul">{`Ophilia: HHVx4`}</li>
      <li parentName="ul">{`Therion: Peacock/Soulstone M`}</li>
    </ul>
    <h3 {...{
      "id": "ophilia-ch4"
    }}>{`Ophilia Ch.4`}</h3>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`, `}<em parentName="p">{`pick `}<strong parentName="em">{`Light M`}</strong>{` if you have no M soulstones left`}</em>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Forest of Purgation`}</strong>{`. Pick `}<strong parentName="p">{`Light L`}</strong>{` + `}<strong parentName="p">{`Tempest Amulet`}</strong>{`.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Cat’s Eye`}</strong>{`, kill encounter with Arrow Storm + Lightning Blast x4 (with Peacock) + Soulstone M`}</p>
    <p>{`Get `}<strong parentName="p">{`Soulstone M`}</strong>{` from shop (If you don’t have 88k before Mattias, sell items).`}</p>
    <p>{`Get `}<strong parentName="p">{`Giants Club`}</strong>{` from gold chest near entrance, get `}<strong parentName="p">{`Adamantite Hat`}</strong>{` and equip Prim, with menu below:`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-2"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Adamantite Hat`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-2"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Apothecary`}</strong>{`, 3 Apoc Skills, `}<strong parentName="li">{`Back to Merchant`}</strong>{`.`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Apothecary`}</strong>{`.`}</li>
        <li parentName="ul"><em parentName="li">{`If you want a safer Mattias and Redeye, you can teach Tressa 2 Warrior skills + Cover.`}</em></li>
      </ul>
      <h5 {...{
        "id": "skills-1"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Endless Items, Hale and Hearty`}</li>
        <li parentName="ul">{`Tressa: Endless Items`}</li>
      </ul>
    </Menu>
    <p>{`Kill encounter with Light L x2 or 1 Light L + any L, and Lightning Blast as needed (will need x 3 + Peacock for mushrooms).`}</p>
    <p>{`Pick `}<strong parentName="p">{`30000$`}</strong>{`, save at Mattias (optional)`}</p>
    <h4 {...{
      "id": "cultists"
    }}>{`Cultists`}</h4>
    <h6 {...{
      "id": "turn-1-3"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Pom S self`}</li>
      <li parentName="ul">{`Ophilia: Holy Light`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Peacock Prim`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-3"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Tressa: HHM x3 (Bandits to fix range)`}</li>
      <li parentName="ul">{`Primrose: Lightning Blast x4`}</li>
      <li parentName="ul">{`Any: Soulstone M if you have a spare`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h6>
    <p><em parentName="p">{`(damage range if no spare soulstones to use)`}</em>{` Primrose Moonlight Waltz/Fireball`}</p>
    <h4 {...{
      "id": "mattias"
    }}>{`Mattias`}</h4>
    <h6 {...{
      "id": "turn-1-4"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Blizzard`}</li>
      <li parentName="ul">{`Ophilia: Pom L self`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Armor Corrosivex2`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-4"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Tressa: HHVx3`}</li>
      <li parentName="ul">{`Primrose: Pom L Tressa`}</li>
      <li parentName="ul">{`Ophilia: HHVx4`}</li>
      <li parentName="ul">{`Therion: Peacock Prim`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-3"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Lighting Blastx4`}</li>
      <li parentName="ul">{`Tressa: HHVx4`}</li>
      <li parentName="ul">{`Ophilia: HHVx3`}</li>
    </ul>
    <p>{`Black Gale hits ~1500`}</p>
    <p>{`If Mattias hits someone twice and they die, use Tressa to prioritize breaking Mattias (use mercenaries instead of vets, olive + heal up to ~1400.  Break on T5 (use sword/blizzard), refresh Armor Corrosive stacks, use BP Donate/ Pom M as needed for vets usage and kill on T6.`}</p>
    <h3 {...{
      "id": "dreisang"
    }}>{`Dreisang`}</h3>
    <p>{`TP `}<strong parentName="p">{`Atlasdam`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`House Landar Records`}</strong>{` from bottom-left guy downstairs. Go to bottom-left side part of town to guide Whispermill guy. `}</p>
    <p>{`TP `}<strong parentName="p">{`Whispermill`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Nourishing L`}</strong>{` from blonde guy near shop, and complete quest to the top-right by windmill for `}<strong parentName="p">{`$22000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Riverford`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick the `}<strong parentName="p">{`Fire L`}</strong>{`, complete quest (guy to the right) for `}<strong parentName="p">{`$15000`}</strong>{` + `}<strong parentName="p">{`Revitalizing Jam`}</strong>{`. Buy `}<strong parentName="p">{`Nourishing L`}</strong>{` from guy near right exit.`}</p>
    <p>{`TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Talk to orange bubble NPC, buy River Blossom from child, talk to kid above to complete quest for `}<strong parentName="p">{`Badge of Friendship`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Dreisang requires 3 Pom L + 1 Revitalizing Jam at minimum.`}<br parentName="p"></br>{`
`}{`If you don’t have a spare Pom L, purchase one from the man near Saintsbridge transition.`}</p>
    </blockquote>
    <p>{`TP `}<strong parentName="p">{`Victors Hollow`}</strong>{`, head to `}<strong parentName="p">{`Duskbarrow`}</strong>{`.  `}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-3"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Scholar`}</strong>{`, 4 Skills, `}<strong parentName="li">{`Merchant`}</strong>{`, Donate BP + HH`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Cleric`}</strong>{`, 4 Skills, `}<strong parentName="li">{`back to Apothecary`}</strong></li>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Warrior`}</strong>{`, Thousand Spears`}</li>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Scholar`}</strong></li>
      </ul>
      <h5 {...{
        "id": "skills-2"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Precipence`}</li>
        <li parentName="ul">{`Tressa: Evasive Maneuvers, Endless Items, Evil Ward`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-3"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Tempest Amulet`}</li>
        <li parentName="ul">{`Tressa: Tempest Amulet + Friendship Badge`}</li>
        <li parentName="ul">{`Primrose: Wind Amulet + Empowering Bracelet `}<strong parentName="li">{`+Knowledge Staff`}</strong>{`.`}</li>
      </ul>
      <h5 {...{
        "id": "items-1"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: all nuts`}</li>
      </ul>
      <p><em parentName="p">{`Heal up`}</em></p>
    </Menu>
    <p>{`S/R or escape encounter with HHBx4/Lightning Blast, pick `}<strong parentName="p">{`Copper-filled Pouch`}</strong>{` and enter `}<strong parentName="p">{`Duskbarrow`}</strong>{`.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Curious Antique`}</strong>{` in top-left corner, pick `}<strong parentName="p">{`$30000`}</strong>{`, buy `}<strong parentName="p">{`Curious Antique`}</strong>{`. `}</p>
    <blockquote>
      <p parentName="blockquote">{`Need 148.2k minimum before going to Archmagus Shrine. If you have more than ~154k, you can buy a `}<strong parentName="p">{`Ruinous Seed`}</strong>{` and skip buying it in Alfyn 2. If you have 148-150k, be very careful with encounters and using Hired Help.`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Gold Items`}</li>
        <li parentName="ul">{`Staffs that aren't `}<strong parentName="li">{`Knowledge Staff`}</strong>{`.`}</li>
      </ul>
    </Menu>
    <p>{`Head to `}<strong parentName="p">{`Shrine of the Archmagus`}</strong>{`.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Pom L`}</strong>{` (left at start), pick `}<strong parentName="p">{`$20000`}</strong>{` (all the way right).`}</p>
    <p>{`You will get an encounter, break knights with Spear/Axe/Ice and constructs with Mercenaries/Sword/Spear, or you can use 1L + Lightning Blast x4 with Peacock for extra EXP`}</p>
    <p>{`Ensure `}<strong parentName="p">{`Ophilia`}</strong>{` has at least `}<strong parentName="p">{`60 SP`}</strong>{` before starting the fight, and `}<strong parentName="p">{`Prim`}</strong>{` has `}<strong parentName="p">{`88 SP`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Optional: Pick `}<strong parentName="p">{`Wizard's Rod`}</strong>{` for an extra $16000. Costs 5.3s before Dreisang & 7.7s after Dreisang.`}</p>
    </blockquote>
    <h4 {...{
      "id": "dreisang-1"
    }}>{`Dreisang`}</h4>
    <h6 {...{
      "id": "turn-1-5"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Pom L Therion `}</li>
      <li parentName="ul">{`Ophilia: Defend`}</li>
      <li parentName="ul">{`Tressa: Spear`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive x2`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-5"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Ophilia: Thousand Spears`}</li>
      <li parentName="ul">{`Primrose: Defend`}</li>
      <li parentName="ul">{`Tressa: Pom M Self`}</li>
      <li parentName="ul">{`Therion: HHV x4`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-4"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Pom L Therion`}</li>
      <li parentName="ul">{`Ophilia: Grape M`}</li>
      <li parentName="ul">{`Tressa: HHVx3`}</li>
      <li parentName="ul">{`Therion: HHVx4`}</li>
    </ul>
    <h6 {...{
      "id": "turn-4"
    }}>{`Turn 4`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Lighting Blast`}</li>
      <li parentName="ul">{`Ophilia: Heal More x4`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive x2`}</li>
      <li parentName="ul">{`Tressa: Collect x4`}</li>
    </ul>
    <h6 {...{
      "id": "turn-5"
    }}>{`Turn 5`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Lighting Blast`}</li>
      <li parentName="ul">{`Tressa/Therion: Pom L/Rev Jam Self `}</li>
      <li parentName="ul">{`Ophilia: Defend`}</li>
    </ul>
    <h6 {...{
      "id": "turn-6"
    }}>{`Turn 6`}</h6>
    <ul>
      <li parentName="ul">{`Ophilia: Swordx3`}</li>
      <li parentName="ul">{`Primrose: Lightning Blast x4`}</li>
      <li parentName="ul">{`Tressa/Therion: HHV x4`}</li>
    </ul>
    <h6 {...{
      "id": "turn-7"
    }}>{`Turn 7`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Lightning Blast x3`}</li>
      <li parentName="ul">{`Ophilia: Soulstone M`}</li>
      <li parentName="ul">{`Tressa/Therion: HHVx3`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If you don’t have Lightning Blast SP, use a Soulstone L or M instead.`}</p>
    </blockquote>
    <h3 {...{
      "id": "primrose-ch2-continued"
    }}>{`Primrose Ch.2 Continued`}</h3>
    <p>{`TP `}<strong parentName="p">{`Stillsnow`}</strong>{`. Go to tavern, Unequip and replace `}<strong parentName="p">{`Ophilia`}</strong>{` with `}<strong parentName="p">{`Cyrus`}</strong>{` in the tavern interface before alluring.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-4"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Tressa/Therion: +500 HP over Tempest`}</li>
        <li parentName="ul">{`Cyrus: Optimize + 500 HPx2`}</li>
        <li parentName="ul">{`Primrose: Augmentor + Unerring`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-4"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Sorcerer`}</strong>{`, Tonitrus + Elemental Break`}</li>
        <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Dancer`}</strong>{`, Peacock Strut`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "rufus-92-sp"
    }}>{`Rufus 92 sp`}</h4>
    <h6 {...{
      "id": "turn-1-6"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Elemental Break x2`}</li>
      <li parentName="ul">{`Tressa/Therion: BP Donate`}</li>
      <li parentName="ul">{`Cyrus: Peacock Strut x2`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-6"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Tonitrusx3`}</li>
      <li parentName="ul">{`Merchant 1: Spear x3`}</li>
      <li parentName="ul">{`Merchant 2: BP Donate x2`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-5"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Ignisx4`}</li>
    </ul>
    <p>{`Run to `}<strong parentName="p">{`Northreach`}</strong>{`, kill encounter with HHB x2 + Ignis x3/4`}</p>
    <p>{`Buy `}<strong parentName="p">{`Magic L`}</strong>{` from lady in blue, pick `}<strong parentName="p">{`Masters Bow`}</strong>{` from the purple chest in the Tavern, and steal `}<strong parentName="p">{`Pom L`}</strong>{` from the blonde guy on the left.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Pom L is needed for Yvon, can be skipped if we still have one.`}</p>
    </blockquote>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h4 {...{
      "id": "therion-ch2-start"
    }}>{`Therion Ch.2 Start`}</h4>
    <p>{`Steal `}<strong parentName="p">{`Invigorating M + Pom S`}</strong>{` from blonde guy near Tavern before stealing from second guy.`}<br parentName="p"></br>{`
`}{`After stealing from second guy, TP to `}<strong parentName="p">{`Quarrycrest`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch2-continued"
    }}>{`Tressa Ch.2 Continued`}</h3>
    <blockquote>
      <p parentName="blockquote">{`You can steal 2 `}<strong parentName="p">{`Fool's Gold Ore`}</strong>{` from the guy guarding the house. Sells for $8000, costs about 4s.`}</p>
    </blockquote>
    <p>{`Kill an encounter in the manor with Ignisx2.  If you get an encounter outside the manor, you can choose to kill it or flee.`}</p>
    <p>{`Use `}<strong parentName="p">{`Magic L and Invigorating M`}</strong>{` whenever you have to heal SP in the menu.`}</p>
    <h4 {...{
      "id": "omar-92sp"
    }}>{`Omar 92sp`}</h4>
    <h6 {...{
      "id": "turn-1-7"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Elemental Break x2`}</li>
      <li parentName="ul">{`Cyrus: Defend`}</li>
      <li parentName="ul">{`Tressa: Spear`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-7"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Cyrus: Peacock x2 Prim`}</li>
      <li parentName="ul">{`Primrose: Glaciesx4`}</li>
      <li parentName="ul">{`Tressa: Defend/Donate BPx3 if after Prim`}</li>
      <li parentName="ul">{`Therion: Donate Bpx3`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-6"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Tressa: Donate BPx3`}</li>
      <li parentName="ul">{`Primrose: Ignisx4`}</li>
    </ul>
    <p>{`After cutscenes, TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`.`}</p>
    <h4 {...{
      "id": "tressa-ch3-start"
    }}>{`Tressa Ch.3 Start`}</h4>
    <p>{`Do story until purchasing Egbert's Shield. After that, TP to `}<strong parentName="p">{`Quarrycrest`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cyrus-ch2"
    }}>{`Cyrus Ch.2`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Wind M`}</strong>{` from Odette’s house.`}</p>
    <h4 {...{
      "id": "gideon-92-sp"
    }}>{`Gideon 92 sp`}</h4>
    <h6 {...{
      "id": "turn-1-8"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
      <li parentName="ul">{`Cyrus: Peacock Strut x2`}</li>
      <li parentName="ul">{`Tressa/Therion: BP Donate`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-8"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Ignisx4`}</li>
      <li parentName="ul">{`Cyrus: Pom M Primrose`}</li>
      <li parentName="ul">{`Tressa/Therion: Defend`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-7"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Tressa: HHMx4 / HHBx4 if Magic L not used on Prim`}</li>
      <li parentName="ul">{`Therion: Attack x4`}</li>
      <li parentName="ul">{`Primrose: Ignis x4`}</li>
    </ul>
    <h3 {...{
      "id": "cyrus-ch3"
    }}>{`Cyrus Ch.3`}</h3>
    <p>{`TP `}<strong parentName="p">{`Stonegard`}</strong>{`, steal `}<strong parentName="p">{`Fire L`}</strong>{` from guy south of third scruitnize in second screen + `}<strong parentName="p">{`Light & Shadow L`}</strong>{` from merchant guy in courtyard.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If Therion is level 26, steal chance is 65% instead of 80%`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-5"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Scholar`}</strong>{`, 1 skill, `}<strong parentName="li">{`Sorcerer`}</strong></li>
        <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Apothecary`}</strong>{`, + 3 skills`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Dancer`}</strong>{`, Peacock + Mole`}</li>
        <li parentName="ul"><em parentName="li">{`If you want to be safer for this fight, you can teach Cyrus two warrior skills for Cover`}</em></li>
      </ul>
      <h5 {...{
        "id": "skills-3"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Elemental Augmentation`}</li>
        <li parentName="ul">{`Cyrus: Hale and Hearty`}</li>
        <li parentName="ul">{`Tressa: The Show Goes On`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "yvon-92-sp"
    }}>{`Yvon 92 sp`}</h4>
    <h6 {...{
      "id": "turn-1-9"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Elemental Break x2`}</li>
      <li parentName="ul">{`Cyrus: Defend`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut`}</li>
      <li parentName="ul">{`Therion: Pom L Primrose`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Merchant 1 throws the L, Merchant 2 does the other thing.`}</em><br parentName="p"></br>{`
`}{`If you used the Magic L, any L Stone kills the adds. If not you need a Thunder L.`}</p>
    </blockquote>
    <h6 {...{
      "id": "turn-2-9"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Cyrus: Staff x2 (Break Yvon)`}</li>
      <li parentName="ul">{`Primrose: Tonitrus x4`}</li>
      <li parentName="ul">{`Tressa: L Stone / Pom M Primrose`}</li>
      <li parentName="ul">{`Therion: L Stone / Armor Corrosive`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-8"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Ignis x2/x4`}</li>
      <li parentName="ul">{`Cyrus: Soulstone M (Range)`}</li>
      <li parentName="ul">{`Therion: HHV x4/Collect x4/Armor Corrosive`}</li>
      <li parentName="ul">{`Tressa: HHV x4/Collect x4`}</li>
    </ul>
    <p>{`[You can choose to skip the collect here if it’s very dangerous or someone died.]`}</p>
    <blockquote>
      <p parentName="blockquote">{`From here on, `}<strong parentName="p">{`never`}</strong>{` use any `}<strong parentName="p">{`Shadow L or Fire L`}</strong>{`! These will be used for H’aanit 2/3 later.`}</p>
    </blockquote>
    <h3 {...{
      "id": "alfyn-ch1"
    }}>{`Alfyn Ch.1`}</h3>
    <p>{`TP `}<strong parentName="p">{`Clearbrook.`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`11x Injuring Seed`}</li>
        <li parentName="ul">{`31x Plum`}</li>
      </ul>
      <h5 {...{
        "id": "sell-1"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Sell every weapon and both Tempest Amulets, then go to `}<strong parentName="li">{`Equipment`}</strong>{` in the shop and unequip `}<strong parentName="li">{`Cyrus`}</strong>{`.`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If you picked up Wizard's Rod, you want to unequip Cyrus before selling.`}</p>
      </blockquote>
    </Menu>
    <p>{`Replace `}<strong parentName="p">{`Cyrus`}</strong>{` with `}<strong parentName="p">{`Alfyn`}</strong>{`, optimize + 2x 500 HP accessories`}</p>
    <h4 {...{
      "id": "viper-32-sp"
    }}>{`Viper 32 sp`}</h4>
    <p>{`Primrose: Ignisx4 or Glaciesx2 + L Stone`}</p>
    <h4 {...{
      "id": "alfyn-ch2-start"
    }}>{`Alfyn Ch.2 Start`}</h4>
    <p>{`Buy `}<strong parentName="p">{`Magic Nut L`}</strong>{` from Lysa in bottom right of second screen.`}<br parentName="p"></br>{`
`}{`Use the `}<strong parentName="p">{`Magic Nut L`}</strong>{` next time you need to restore SP.`}</p>
    <p>{`Do story stuff until Inquire guy in top part of town, then TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h4 {...{
      "id": "therion-ch2-continued"
    }}>{`Therion Ch.2 Continued`}</h4>
    <blockquote>
      <p parentName="blockquote">{`If Therion is level 27, the last steal is 80%`}</p>
    </blockquote>
    <p>{`Kill encounter with Ignisx2 (if applicable)`}</p>
    <h4 {...{
      "id": "orlick-92-sp"
    }}>{`Orlick 92 sp`}</h4>
    <h6 {...{
      "id": "turn-1-10"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
      <li parentName="ul">{`Tressa: Peacock Prim`}</li>
      <li parentName="ul">{`Therion: Donate BP Prim`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-10"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Glacies x4`}</li>
      <li parentName="ul">{`Tressa: Donate BP x3 Prim`}</li>
      <li parentName="ul">{`Therion/Alfyn: Defend`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-9"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Therion/Alfyn: Axe x4/Dagger x4 `}</li>
      <li parentName="ul">{`Primrose: Ignisx4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch3-continued"
    }}>{`Tressa Ch.3 Continued`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-6"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Cleric`}</strong></li>
        <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Dancer`}</strong>{`, Peacock + Mole`}</li>
      </ul>
      <h5 {...{
        "id": "skills-4"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Peacock + Night Ode`}</strong>{`, Show Must Go On`}</li>
        <li parentName="ul">{`Alfyn: Show Must Go On`}</li>
      </ul>
    </Menu>
    <p>{`Kill encounter in the caves with Glaciesx3/4 `}</p>
    <p>{`Pick `}<strong parentName="p">{`Pom L`}</strong>{` after 6th torch if low on pomegranates, pick `}<strong parentName="p">{`$15000`}</strong>{` (If you skip this chest, you cannot use a second vet in Olberic Ch 2).`}</p>
    <h4 {...{
      "id": "venomtooth-tiger-92-sp"
    }}>{`Venomtooth Tiger 92 sp`}</h4>
    <h6 {...{
      "id": "turn-1-11"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Ignis`}</li>
      <li parentName="ul">{`Alfyn: Concoct (Injuring + Nox)`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-11"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Tressa: Holy Light`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
      <li parentName="ul">{`Alfyn: Peacock Prim`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-10"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Ignisx4`}</li>
      <li parentName="ul">{`Merchants: Collectx4 + HHVx4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Wellspring`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch3"
    }}>{`Therion Ch.3`}</h3>
    <p>{`Forced fight 2xIgnis`}</p>
    <h4 {...{
      "id": "gareth-92-sp"
    }}>{`Gareth 92 sp`}</h4>
    <blockquote>
      <p parentName="blockquote">{`If turn order is really scary (or if you miss Elemental Break), Prim can Defend T1. T2 have Tressa & Alfyn throw L Stones.`}</p>
    </blockquote>
    <h6 {...{
      "id": "turn-1-12"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
      <li parentName="ul">{`Alfyn: Peacock`}</li>
      <li parentName="ul">{`Tressa: HHMx2`}</li>
      <li parentName="ul">{`Therion: Donate BP`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-12"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Glacies x4`}</li>
      <li parentName="ul">{`Therion: BP Donatex3`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-11"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Ignis x4`}</li>
    </ul>
    <p>{`After cutscenes, tag `}<strong parentName="p">{`S’warkii`}</strong>{`. TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch2-continued"
    }}>{`Alfyn Ch.2 Continued`}</h3>
    <h4 {...{
      "id": "vanessa-92-sp"
    }}>{`Vanessa 92 sp`}</h4>
    <h6 {...{
      "id": "turn-1-13"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Elemental Break x2`}</li>
      <li parentName="ul">{`Alfyn: Peacock`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Donate BPx2`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-13"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Tressa: Donate BPx3`}</li>
      <li parentName="ul">{`Primrose: Glacies x4`}</li>
      <li parentName="ul">{`Therion/Alfyn: Nothing`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-12"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Ignis x3`}</li>
    </ul>
    <p>{`Buy `}<strong parentName="p">{`Ruinous Seed`}</strong>{` from the lady on the small bridge after.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch3-start"
    }}>{`Alfyn Ch.3 Start`}</h3>
    <p>{`After the first cutscene, get the `}<strong parentName="p">{`Pom M`}</strong>{` chest.`}<br parentName="p"></br>{`
`}{`Do story stuff until inquiring guy below tavern. TP to `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch3"
    }}>{`Primrose Ch.3`}</h3>
    <p>{`In `}<strong parentName="p">{`Obsidian Manse`}</strong>{` S+Q if you took the encounter outside Seashore Grotto, else kill encounter with x4 Glacies/Ignis.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Safe strat, consider using if Albus before Prim T2. Loses Collect.`}<br parentName="p"></br>{`
`}{`T1: Prim 2xEBreak Therion 2xDonate BP`}<br parentName="p"></br>{`
`}{`T2: Tressa 2xMercs`}<br parentName="p"></br>{`
`}{`T3: First Merchant Max BP Donate BP other Merchant, 2nd Merchant 4xVets`}</p>
    </blockquote>
    <h4 {...{
      "id": "albus-60sp"
    }}>{`Albus 60sp`}</h4>
    <h6 {...{
      "id": "turn-1-14"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Peacock Strut Self`}</li>
      <li parentName="ul">{`Alfyn: Concoct (Ruinous + Addlewort)`}</li>
      <li parentName="ul">{`Tressa/Therion: HHM/Tradewinds`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-14"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
      <li parentName="ul">{`Alfyn: Concoct (Injurous + Addlewort) OR Defend if Primrose missed EB/someone died`}</li>
      <li parentName="ul">{`Tressa: Tradewinds`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If Prim got blinded and missed EBreak, skip Collect & throw L Stones with Merchant & Alfyn.`}</p>
    </blockquote>
    <h6 {...{
      "id": "turn-3-13"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Ignis x4`}</li>
      <li parentName="ul">{`Merchant 1: Collect x4`}</li>
      <li parentName="ul">{`Merchant 2: HHV x4`}</li>
    </ul>
    <h1 {...{
      "id": "important"
    }}>{`IMPORTANT`}</h1>
    <p>{`Check your EXP after Albus - if Primrose is more than 800 xp `}<strong parentName="p">{`to a level`}</strong>{`, do Miguel before Simeon `}{`[This assumes you do Miguel before Simeon]`}{`.  If they are all within 800 xp, do Simeon first, after inquiring the man at the tavern in Alfyn 3. At this point you should have enough JP for the menu below:`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-7"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Warrior`}</strong>{`, All Warrior Skills, `}<strong parentName="li">{`Sorcerer`}</strong></li>
        <li parentName="ul">{`Tressa: All Cleric Skills`}</li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Scholar`}</strong>{`, All Scholar Skills`}</li>
      </ul>
      <h5 {...{
        "id": "skills-5"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Surpassing Power`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-5"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Knowledge Staff (!)`}</strong></li>
      </ul>
    </Menu>
    <p>{`If not, always do Miguel first, then Simeon.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Miguel gives 660 EXP while Simeon 1 gives 880 EXP.`}</p>
    </blockquote>
    <h3 {...{
      "id": "alfyn-ch3-continued"
    }}>{`Alfyn Ch.3 Continued`}</h3>
    <blockquote>
      <p parentName="blockquote">{`You can optionally choose to steal all `}<strong parentName="p">{`Pomegranates`}</strong>{` from the man before the next screen transition, and/or steal the `}<strong parentName="p">{`Wind M/L`}</strong>{` from the man at the bridge on the next screen.`}</p>
    </blockquote>
    <h4 {...{
      "id": "miguel-56-sp"
    }}>{`Miguel 56 sp`}</h4>
    <h6 {...{
      "id": "turn-1-15"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Bow`}</strong></li>
      <li parentName="ul">{`Alfyn: Concoct (Injurious + Addlewort)`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: `}<strong parentName="li">{`Sword`}</strong></li>
    </ul>
    <h6 {...{
      "id": "turn-2-15"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Bowx3`}</strong></li>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
      <li parentName="ul">{`Alfyn: Peacock Prim`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-14"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Therion: Alephan`}</li>
      <li parentName="ul">{`Primrose: Ignis x4`}</li>
    </ul>
    <h3 {...{
      "id": "primrose-ch4"
    }}>{`Primrose Ch.4`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Fire L`}</strong>{`, `}<strong parentName="p">{`Ice L`}</strong>{`, `}<strong parentName="p">{`Wind L`}</strong>{`, a few M Stones and optionally the other 2 L Stones.`}<br parentName="p"></br>{`
`}{`Can pick `}<strong parentName="p">{`Light L`}</strong>{`. Can pick `}<strong parentName="p">{`Pom L`}</strong>{` but shouldn't be needed.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You want to save the Ice L for Ogre Eagle and 1 Ice L or Wind L for Olberic 3. A Wind L is also nice for Victorino.`}</p>
    </blockquote>
    <p>{`For Simeon 1 and 2, if characters go before Primrose on turn 3 or 4 respectively, you can replace their actions with a Grape Bunch/Grape M.`}</p>
    <Cait mdxType="Cait">
      <blockquote>
        <p parentName="blockquote">{`With Cait Tressa won't level up on this battle. So if you have an option on who to heal heal her.`}</p>
      </blockquote>
    </Cait>
    <h4 {...{
      "id": "simeon-1-56sp"
    }}>{`Simeon 1 56sp`}</h4>
    <h6 {...{
      "id": "turn-1-16"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Defend / Can heal if before Simeon T2`}</li>
      <li parentName="ul">{`Alfyn: Dagger x2 Simeon`}</li>
      <li parentName="ul">{`Tressa: HHM/Grape Bunch/Heal More/Grape`}</li>
      <li parentName="ul">{`Therion: Shackle Foe/Grape Bunch/Grape M`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-16"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
      <li parentName="ul">{`Alfyn: Heal`}</li>
      <li parentName="ul">{`Therion/Tressa: Defend`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-15"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Therion/Tressa: Alephan+Aelfric`}</li>
      <li parentName="ul">{`Primrose: Ignis x4 Simeon`}</li>
    </ul>
    <p><em parentName="p">{`Ideally all characters should level up after this. You can generally win if Tressa/Therion are dead at the start of this fight`}</em></p>
    <h4 {...{
      "id": "simeon-2-56sp"
    }}>{`Simeon 2 56sp`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Only thing to really lookout for is that Prim isn't silenced during T2 so she can Peacock herself.`}<br parentName="p"></br>{`
`}{`Otherwise, just focus on getting him to 4 Shield for T2.`}</p>
    </blockquote>
    <h6 {...{
      "id": "turn-1-17"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Attack / Heal`}</li>
      <li parentName="ul">{`Alfyn: Dagger / Heal`}</li>
      <li parentName="ul">{`Tressa: Heal / HHM / Dancer / Defend`}</li>
      <li parentName="ul">{`Therion: Dagger / Shackle Foe / Grape Bunch`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-17"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Peacock Self / Attack`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
      <li parentName="ul">{`Tressa: HHD/Grape Bunch/Grape M`}</li>
      <li parentName="ul">{`Therion: Dagger/Grape Bunch`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-16"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
      <li parentName="ul">{`Alfyn: Dagger x4`}</li>
      <li parentName="ul">{`Tressa/Therion: Alephan + Aelfric`}</li>
    </ul>
    <h6 {...{
      "id": "turn-4-1"
    }}>{`Turn 4`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Ignisx4`}</li>
    </ul>
    <p>{`You get autohealed after Prim 4 and during Alfyn 4. TP to `}<strong parentName="p">{`Orewell`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch4"
    }}>{`Alfyn Ch.4`}</h3>
    <h4 {...{
      "id": "ogre-eagle-6092sp"
    }}>{`Ogre Eagle 60/92sp`}</h4>
    <h6 {...{
      "id": "turn-1-18"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Peacock`}</li>
      <li parentName="ul">{`Alfyn: Defend / Icicle if Alfyn 1st T2`}</li>
      <li parentName="ul">{`Tressa: Ice L / Status Heal if Alfyn 1st T2`}</li>
      <li parentName="ul">{`Therion: Blizzard`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-18"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
      <li parentName="ul">{`Alfyn: Icicle / Ice L if Alfyn 1st T2`}</li>
      <li parentName="ul">{`Tressa/Therion: Defend`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-17"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Tressa/Therion: Alephan/Aelfric`}</li>
      <li parentName="ul">{`Primrose: Ignis x4`}</li>
      <li parentName="ul">{`Alfyn: M Stone (rare range)`}</li>
    </ul>
    <hr></hr>
    <h4 {...{
      "id": "if-prim-before-eagle-on-t2"
    }}>{`If Prim before Eagle on T2`}</h4>
    <h6 {...{
      "id": "turn-1-19"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Elemental Breakx2`}</li>
      <li parentName="ul">{`Alfyn: Peacock / Status Heal / Icicle if needed`}</li>
      <li parentName="ul">{`Tressa: Pom M Prim / Status Heal if needed`}</li>
      <li parentName="ul">{`Therion: Blizzard`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-19"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Glacies`}</li>
      <li parentName="ul">{`Tressa/Therion: Defend`}</li>
      <li parentName="ul">{`Alfyn: Peacock / Pom M Prim / Nothing`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-18"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Tressa/Therion: Alephan/Aelfric`}</li>
      <li parentName="ul">{`Primrose: Ignisx4`}</li>
      <li parentName="ul">{`Alfyn: M Stone if Peacock after Glacies (range)`}</li>
    </ul>
    <h3 {...{
      "id": "haanit-ch1"
    }}>{`H'aanit Ch.1`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-6"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: +50 SP over +50 Accuracy`}</li>
        <li parentName="ul">{`Unequip `}<strong parentName="li">{`Alfyn`}</strong>{`.  `}</li>
        <li parentName="ul">{`Tressa: +500 HP over Badge`}</li>
      </ul>
      <h5 {...{
        "id": "skills-6"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Ventus + Lux, Elemental Aid over The Show Goes On + Stronger Strikes.`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`S’warkii`}</strong>{`. Swap `}<strong parentName="p">{`Alfyn`}</strong>{` for `}<strong parentName="p">{`H’aanit`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-7"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`H’aanit: Optimize + 500 HPx2`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "ghisarma-72sp"
    }}>{`Ghisarma 72sp`}</h4>
    <p>{`Primrose: Glaciesx3 OR Glaciesx2 + L Stone`}</p>
    <h3 {...{
      "id": "haanit-ch2"
    }}>{`H'aanit Ch.2`}</h3>
    <p>{`TP `}<strong parentName="p">{`Stonegard`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Provoke 1: 2x Fire L + 1 M`}<br parentName="p"></br>{`
`}{`Provoke 2: Light/Fire L + Any L OR 3x Fox + 1 L`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-8"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`H'aanit: Leghold,  `}<strong parentName="li">{`Dancer`}</strong>{`, Peacock`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "lord-of-the-forest-92sp"
    }}>{`Lord of the Forest 92sp`}</h4>
    <blockquote>
      <p parentName="blockquote">{`If you accidently Donate BP Prim, replace Peacock or EBreak with Pom S Therion. 1 buff + Alephan + 4xIgnis kills`}</p>
    </blockquote>
    <h6 {...{
      "id": "turn-1-20"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
      <li parentName="ul">{`H'aanit: Peacock `}<strong parentName="li">{`Primrose`}</strong></li>
      <li parentName="ul">{`Tressa: Donate BP `}<strong parentName="li">{`Therion`}</strong></li>
      <li parentName="ul">{`Therion: Defend`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-20"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Therion: Alephan`}</li>
      <li parentName="ul">{`Primrose: Ignisx3`}</li>
    </ul>
    <h3 {...{
      "id": "haanit-ch3"
    }}>{`H'aanit Ch.3`}</h3>
    <p>{`TP `}<strong parentName="p">{`Stillsnow`}</strong>{`. Provoke: 1x Fox + 2 Shadow L + 1L`}</p>
    <h4 {...{
      "id": "dragon-164sp"
    }}>{`Dragon 164sp`}</h4>
    <h6 {...{
      "id": "turn-1-21"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Lux`}</li>
      <li parentName="ul">{`H’aanit: Peacock x2 Prim`}</li>
      <li parentName="ul">{`Tressa/Therion: Defend`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-21"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Tressa: Holy Light`}</li>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-19"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Therion: Alephan`}</li>
      <li parentName="ul">{`Primrose: Ignis x4`}</li>
    </ul>
    <h3 {...{
      "id": "haanit-ch4"
    }}>{`H'aanit Ch.4`}</h3>
    <p>{`TP `}<strong parentName="p">{`Marsalim`}</strong>{`. Steal `}<strong parentName="p">{`Pom L x2`}</strong>{` from the blue man on your way upstairs.`}</p>
    <p>{`Pick `}<strong parentName="p">{`$50000`}</strong>{` and `}<strong parentName="p">{`$30000`}</strong>{` chests in Grimsand Ruins.`}</p>
    <blockquote>
      <p parentName="blockquote">{`This is fight is always cleanly winnable as long as you have someone between Redeye turns T1.`}<br parentName="p"></br>{`
`}{`You have 3 goals for T1, from then on the fight is free.`}</p>
      <ol parentName="blockquote">
        <li parentName="ol">{`Don't let anyone die. AKA whoever is between Redeye turns heal whoever got hit. Best to worst characters to heal with: Tressa, H'aanit, Primrose, Therion.`}</li>
        <li parentName="ol">{`Get Prim before Redeye T2. A lot of the time she'll be faster by default, but if not Defend or Leghold.`}</li>
        <li parentName="ol">{`Break 2 Shields, he needs to be 3 Shields or less T2 so Prim can break.`}</li>
      </ol>
      <p parentName="blockquote">{`If he does manage to double tap someone, it can be recovered. It might rely on getting a good turn order T3 so you can skip a Defend T2 and use a Pom. Luckily, odds of him double tapping someone are low thanks to heals & Cover.`}</p>
      <p parentName="blockquote">{`Damagewise, Alephans + Aelfrics + Peacock + Ignisx4 does ~17000-~17600 * 6 = ~102000-~105600`}<br parentName="p"></br>{`
`}{`The Lux used to break will do ~3300, ~4650 with Peacock & about 500 more for every Shield below 3.`}<br parentName="p"></br>{`
`}{`You will generally need an M Stone to finish him, very rarely you might need an L with really bad rolls.`}<br parentName="p"></br>{`
`}{`If you have a free turn on someone, you can also just Pom M Prim T1. BPx2 Lux will do roughly double the damage above.`}</p>
      <p parentName="blockquote">{`I'm not going to cover all possible fights in the turns below, just give a rough outline of how it goes. I recommend practicing this fight a bit, it's not hard at all and you'll get a much better feel for it doing it a few times instead of reading all this.`}</p>
    </blockquote>
    <h4 {...{
      "id": "redeye-164sp-108815hp"
    }}>{`Redeye 164sp 108815HP`}</h4>
    <h6 {...{
      "id": "turn-1-22"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul"><em parentName="li">{`Heal isn't listed, but all characters prioritize healing over everything else.`}</em></li>
      <li parentName="ul">{`Primrose: Defend / Attack`}</li>
      <li parentName="ul">{`H’aanit: Leghold Trap if Prim can't Defend & is after Redeye T2 / 2xPeacock / 2xBow or Rain of Arrows if Therion had to heal`}</li>
      <li parentName="ul">{`Tressa: Heal / Bow / Mercs / Nothing`}</li>
      <li parentName="ul">{`Therion: Firestorm`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-22"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Lux`}</strong></li>
      <li parentName="ul">{`Tressa/Therion: Defend`}</li>
      <li parentName="ul">{`H’aanit: Peacock Prim / Nothing`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-23"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Tressa/Therion: Alephan/Aelfric`}</li>
      <li parentName="ul">{`Primrose: Ignisx4`}</li>
      <li parentName="ul">{`H'aanit: M/L Stone (range)`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Saving is optional as recovering from this battle if he kills someone or Prim misses Elemental Break is difficult.`}</p>
    </blockquote>
    <h4 {...{
      "id": "bishops-staff"
    }}>{`Bishop's Staff`}</h4>
    <p>{`Unequip H'aanit. TP `}<strong parentName="p">{`Flamesgrace`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
Unequip H'aanit.
    </Menu>
    <p>{`Go to Tavern, swap H'aanit for Cyrus. Go to church, purchase `}<strong parentName="p">{`Bishop's Staff`}</strong>{` from Lianna.`}</p>
    <p>{`TP `}<strong parentName="p">{`Duskbarrow`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cyrus-ch4"
    }}>{`Cyrus Ch.4`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-8"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Optimize, replace Stimulating Bracelet with `}<strong parentName="li">{`Empowering Bracelet`}</strong>{`.`}</li>
        <li parentName="ul">{`Therion: Optimize, remove `}<strong parentName="li">{`Empowering Bracelet`}</strong>{`.`}</li>
        <li parentName="ul">{`Cyrus: Optimize, 2 Empowering Bracelets.`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-9"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Tenebrae`}</li>
        <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold Trap`}</li>
      </ul>
      <h5 {...{
        "id": "skills-7"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Augmented Elements over Stronger Strikes`}</li>
      </ul>
      <p><strong parentName="p">{`Heal Up`}</strong></p>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`Options 2, 2, 2`}</p>
    </blockquote>
    <p>{`You really want to have at least 1 Healing Grape Bunch, possibly 2 but shouldn't be necessary. If you don't have one the right chest at the entrance is a Healing Grape Bunch.`}</p>
    <p>{`If you don't have a Ice L or Wind L, you can pick the `}<strong parentName="p">{`Ice L`}</strong>{` on the second screen. It's the first chest after the library.`}</p>
    <h4 {...{
      "id": "lucia-96sp"
    }}>{`Lucia 96sp`}</h4>
    <h6 {...{
      "id": "turn-1-23"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul"><em parentName="li">{`If both Therion & Tressa before Lucia, use HHM / Shackle. If one before, use that persons buff & HGB with the other. If both after, Shackle Foe + HGB.`}</em></li>
      <li parentName="ul">{`Primrose: 2xPeacock Self`}</li>
      <li parentName="ul">{`Cyrus: Leghold Trap`}</li>
      <li parentName="ul">{`Tressa: HHM / Heal`}</li>
      <li parentName="ul">{`Therion: Shackle Foe / Heal`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-24"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul"><em parentName="li">{`Anyone that's before Prim T3 can heal here.`}</em></li>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
      <li parentName="ul">{`Cyrus: Pom M Prim / Heal`}</li>
      <li parentName="ul">{`Tressa: Defend / Heal`}</li>
      <li parentName="ul">{`Therion: Defend / Heal`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-20"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Lux Congerere`}</strong>{` x4`}</li>
      <li parentName="ul">{`Cyrus: Pom M Prim if not done already.`}</li>
      <li parentName="ul">{`Tressa: Aelfrics`}</li>
      <li parentName="ul">{`Therion: Alephans`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Options 2, 3, 2`}</p>
    </blockquote>
    <h4 {...{
      "id": "olberic-ch1-72sp"
    }}>{`Olberic Ch.1 72sp`}</h4>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "unequip"
      }}>{`Unequip`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Swap `}<strong parentName="li">{`Empowering Bracelet`}</strong>{` for `}<strong parentName="li">{`Stimulating Bracelet`}</strong>{`.`}</li>
        <li parentName="ul">{`Cyrus: Unequip`}</li>
        <li parentName="ul">{`Therion: Equip `}<strong parentName="li">{`Empowering Bracelet`}</strong>{`.`}</li>
      </ul>
      <h5 {...{
        "id": "skills-8"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Swap Elemental Augmentaion for Stronger Strikes`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Cobbleston`}</strong>{`, swap `}<strong parentName="p">{`Cyrus`}</strong>{` with `}<strong parentName="p">{`Olberic`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-9"
      }}>{`Equipment`}</h5>
      <p>{`Olberic: Optimize + 500 HPx2`}</p>
    </Menu>
    <p><em parentName="p">{`Night Ode`}</em>{`, Therion 2xFireball, or M Stone first encounter`}</p>
    <p>{`Gaston: Ignis x2`}</p>
    <p>{`TP `}<strong parentName="p">{`Northreach`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch4-start"
    }}>{`Therion Ch.4 Start`}</h3>
    <p>{`Kill encounter with 2x Tonitrus.`}</p>
    <p>{`Inspirating Plum Primrose once unless you leveled. Otherwise not enough SP for Victorino. TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`. `}</p>
    <h3 {...{
      "id": "olberic-ch2"
    }}>{`Olberic Ch.2`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-10"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: `}<strong parentName="li">{`Merchant`}</strong>{`, Donate BP, HH`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Dancer`}</strong></li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Victors Hollow`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Need ~162k for Challeneges. If you're short can Spear/Sword, Attack x3, L Stone.`}</p>
    </blockquote>
    <p><strong parentName="p">{`Challenges`}</strong>{`: HHV`}</p>
    <p><strong parentName="p">{`Victorino`}</strong>{`: Ventus x3 OR 2xVentus and Wind L`}</p>
    <blockquote>
      <p parentName="blockquote">{`You’re healed between each battle so no menuing to heal SP is necessary.`}</p>
    </blockquote>
    <p><strong parentName="p">{`Joshua`}</strong>{`: 4xLux`}</p>
    <p><strong parentName="p">{`Archibold`}</strong>{`: Peacock + Tenebrae x3`}</p>
    <h4 {...{
      "id": "gustav-72"
    }}>{`Gustav 72`}</h4>
    <h6 {...{
      "id": "turn-1-24"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Glacies x2`}</li>
      <li parentName="ul">{`Olberic: Defend + Donate BPx3 Prim / Pom L Prim`}</li>
      <li parentName="ul">{`Tressa: Donate BP Therion`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-25"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Therion: Alephan`}</li>
      <li parentName="ul">{`Primrose: 4xIgnis`}</li>
      <li parentName="ul">{`Tressa: Maybe M Stone (might be range)`}</li>
    </ul>
    <h3 {...{
      "id": "olberic-ch3"
    }}>{`Olberic Ch.3`}</h3>
    <p>{`TP `}<strong parentName="p">{`Wellspring`}</strong>{`.`}</p>
    <p>{`Heal to 144 SP before the lizard battles, Glacies x2`}</p>
    <h4 {...{
      "id": "lizardman-chief-92sp"
    }}>{`Lizardman Chief 92sp`}</h4>
    <h6 {...{
      "id": "turn-1-25"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
      <li parentName="ul">{`Olberic: Donate BP Primrose`}</li>
      <li parentName="ul">{`Tressa: Peacock`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-26"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Therion: Ice / Wind L`}</li>
      <li parentName="ul">{`Primrose: Lux Congerere x4`}</li>
    </ul>
    <p><strong parentName="p">{`Erhardt`}</strong>{` HHV, HHVx3`}</p>
    <h3 {...{
      "id": "olberic-ch4"
    }}>{`Olberic Ch.4`}</h3>
    <p>{`TP `}<strong parentName="p">{`Riverford`}</strong>{`.`}</p>
    <p><strong parentName="p">{`Red Hat guy`}</strong>{`: Pom L, HHVx4, HHVx3`}</p>
    <p>{`After entering manse from hidden path, TP `}<strong parentName="p">{`Riverford`}</strong>{` and go to manse.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If anyone but Therion gets Terrored you're good, 3xLux kills. Just have Tressa heal Terror T2 if it's Prim.`}<br parentName="p"></br>{`
`}{`If Therion gets Terrored skip EBreak & Heal Terror + Donate BP Therion`}<br parentName="p"></br>{`
`}{`4xLux without EBreak + 2 L Stones or 1 Vet will kill.`}</p>
    </blockquote>
    <h4 {...{
      "id": "werner-164sp"
    }}>{`Werner 164sp`}</h4>
    <h6 {...{
      "id": "turn-1-26"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Lux Congerere`}</li>
      <li parentName="ul">{`Olberic: Defend x2`}</li>
      <li parentName="ul">{`Tressa: Peacock Prim`}</li>
      <li parentName="ul">{`Therion: Attack`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-27"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Olberic: Tradewinds`}</li>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
      <li parentName="ul">{`Tressa: Nothing / Heal Terror / Donate BP`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-21"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Therion: Alephan`}</li>
      <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Lux Congerere`}</strong>{` x4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Northreach.`}</strong></p>
    <h3 {...{
      "id": "therion-ch4"
    }}>{`Therion Ch.4`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-10"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: -2 Empowering Bracelet`}</li>
        <li parentName="ul">{`Primrose: +2 Empowering Bracelet`}</li>
      </ul>
      <h5 {...{
        "id": "skills-9"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: The Show Goes On over Stronger Strikes`}</li>
      </ul>
      <p><em parentName="p">{`Heal up`}</em>{`.`}</p>
    </Menu>
    <p>{`8% steal skill time.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Darius shouldn't be able to kill Therion or Prim. It's fine if he kills Tressa or Olberic`}</p>
    </blockquote>
    <h3 {...{
      "id": "darius-92sp"
    }}>{`Darius 92sp`}</h3>
    <h6 {...{
      "id": "turn-1-27"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Peacock`}</li>
      <li parentName="ul">{`Olberic: Defend`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Attack`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-28"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Olberic or Tressa: `}<strong parentName="li">{`Spear`}</strong>{` x3`}</li>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-22"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Therion: Alephan`}</li>
      <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Lux Congerere`}</strong>{` x4`}</li>
    </ul>
    <h3 {...{
      "id": "tressa-ch4"
    }}>{`Tressa Ch.4`}</h3>
    <p>{`TP `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Esmeralda shouldn't be able to kill Therion or Prim. It saves time if she kills Olberic or Tressa.`}</p>
    </blockquote>
    <h4 {...{
      "id": "esmeralda-96sp"
    }}>{`Esmeralda 96sp`}</h4>
    <h6 {...{
      "id": "turn-1-28"
    }}>{`Turn 1`}</h6>
    <ul>
      <li parentName="ul">{`Primrose: Peacock`}</li>
      <li parentName="ul">{`Olberic/Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: `}<strong parentName="li">{`Staff`}</strong></li>
    </ul>
    <h6 {...{
      "id": "turn-2-29"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Olberic/Tressa: 3xSpear`}</li>
      <li parentName="ul">{`Primrose: Elemental Break`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-23"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Therion: Alephan`}</li>
      <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Lux Congerere`}</strong>{` x4`}</li>
    </ul>
    <h2 {...{
      "id": "fin"
    }}>{`FIN`}</h2>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      